import * as React from "react"
import { connect } from "react-redux"
import { GlobalState } from "../../../../store"

import AuthBasePage from "../../AuthBasePage"
import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"

import { mapDispatchToProps, DispatchProps } from "../../actions"
import env from "../../../../env"
import { clearSearchQuery } from "../../../../components/search/persist"
import { ILogoutPage } from "../../index"

type StateProps = ILogoutPage

type Props = StateProps & DispatchProps

export class LogoutPage extends React.Component<Props> {
    componentDidMount(): void {
        clearSearchQuery()
        this.props.requestLogout()
    }

    render(): JSX.Element {
        const { errorMessage } = this.props

        return (
            <AuthBasePage>
                <div>
                    {!!errorMessage ? (
                        <div className="theme-bubble bg-cadmium-red text-white tw-px-3 tw-py-1 tw-w-fit">
                            <h4>Your logout was unsuccessful.</h4>
                            <p>{errorMessage}</p>
                        </div>
                    ) : (
                        <>
                            <h3
                                id="logoutSuccessMessage"
                                className="tw-mx-4 tw-mb-4 is-inverted"
                            >
                                You have successfully logged out. <br /> Thank
                                you and have a great day!
                            </h3>
                            <p className="tw-mx-4 tw-mb-4 is-inverted is-dimmed">
                                You will be automatically redirected to the
                                login page shortly.
                            </p>
                        </>
                    )}
                    <div>
                        <ActionAnchor
                            href={env.applicationPath + "/"}
                            actionType={ActionType.button}
                            isLabel={true}
                        >
                            Sign in again
                        </ActionAnchor>
                    </div>
                </div>
            </AuthBasePage>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps =>
    state.auth.logoutPage

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage)
